export default "__VITE_ASSET__GE4jf70t__"